import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import getMeetDistinctAthletesWithPersonId from './GetMeetDistinctAthletesWithPersonId';

const MeetDistinctAthletesWithPersonIdData = { INITIAL_STATE: { ...BASIC_INITIAL_STATE, arrayAsOptions: [] }, getMeetDistinctAthletesWithPersonId };
export default MeetDistinctAthletesWithPersonIdData;